"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginPage = void 0;
var react_1 = __importDefault(require("react"));
var react_helmet_1 = require("react-helmet");
var UserManager_1 = __importDefault(require("App/util/UserManager"));
var Loader_1 = __importDefault(require("App/components/Loader"));
var query_string_1 = __importDefault(require("query-string"));
var env_1 = require("App/util/env");
var env = env_1.getEnv({
    OIDC_SIGNIN_TYPE: process.env.REACT_APP_OIDC_SIGNIN_TYPE || 'redirect'
});
exports.LoginPage = function () {
    react_1.default.useEffect(function () {
        var params = query_string_1.default.parse(window.location.search);
        var hootsuiteUserId = params.userId;
        console.log("SIGNIN TYPE: " + env.OIDC_SIGNIN_TYPE);
        console.log("SIGNIN TYPE REACT: " + process.env.REACT_APP_OIDC_SIGNIN_TYPE);
        if (env.OIDC_SIGNIN_TYPE === 'popup') {
            UserManager_1.default.signinPopup({
                extraQueryParams: {
                    hootsuiteUserId: hootsuiteUserId
                },
                extraTokenParams: {
                    hootsuiteUserId: hootsuiteUserId
                }
            });
        }
        else {
            UserManager_1.default.signinRedirect({
                extraQueryParams: {
                    hootsuiteUserId: hootsuiteUserId
                },
                extraTokenParams: {
                    hootsuiteUserId: hootsuiteUserId
                }
            });
        }
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, { title: "Login" }),
        react_1.default.createElement(Loader_1.default, null)));
};
exports.default = {
    name: 'Login',
    routeProps: {
        path: '/login',
        component: exports.LoginPage,
    },
};
//# sourceMappingURL=index.js.map